module.exports = __webpack_public_path__ + "react/assets/formDisplay/centerRight.gif";